import { render } from "./MMAdminSustainableMining.vue?vue&type=template&id=116f4897"
import script from "./MMAdminSustainableMining.vue?vue&type=script&lang=js"
export * from "./MMAdminSustainableMining.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__